import styled from 'styled-components';
import { themeGet } from 'styled-system';

export const SimilarJobContainer = styled.div`
  padding: 15px 0;
  &:not(:first-child) {
    border-bottom: 1px solid ${themeGet('colors.paleGreyTwo')};
  }
`;
